import { useRef } from "react";
import { useLayoutProvider } from "../../../../utils/layout";
import { EnhancedEventDetection } from "../../../InteractiveQuickKey/components/InteractivityWrapper/components";
import { ActionItemRenderer } from "./ActionItemRenderer";
import { ActionItemRendererProps } from "./types";

export const DefaultActionItemRenderer = ({
  item,
}: ActionItemRendererProps) => {
  const { startEditing } = useLayoutProvider();
  const tileRef = useRef<any>([]);

  function handleMarkupPress() {
    tileRef.current?.tilePress?.();
  }

  return (
    <EnhancedEventDetection
      onPress={handleMarkupPress}
      onActivate={startEditing}
    >
      <ActionItemRenderer ref={tileRef} {...{ item }} />
    </EnhancedEventDetection>
  );
};
